import React, { useState, useEffect } from 'react';
import axios from 'axios';
import JobSidebar from './JobSidebar';
import { ListTodo } from "lucide-react"

export default function JobPosting() {
  const API_BASE = import.meta.env.VITE_API_BASE_URL;
  const [job, setJob] = useState({
    title: '',
    yoe: '',
    job_location: '',
    link: '',
    job_type: '',
  });
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    if (sidebarOpen) {
      fetchJobs();
    }
  }, [sidebarOpen]);

  const fetchJobs = async () => {
    try {
      const res = await axios.get(`${API_BASE}jobs`);
      setJobs(res.data);
    } catch (err) {
      console.error('Error fetching jobs:', err);
      alert('Failed to fetch jobs!');
    }
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setJob(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    axios
      .post(`${API_BASE}jobs`, job)
      .then(() => {
        alert('Job created successfully!');
        setJob({ title: '', yoe: '', job_location: '', link: '', job_type: '' });
        if (sidebarOpen) fetchJobs();
      })
      .catch(err => {
        console.error('Error uploading job:', err);
        alert('Failed to create job. Please try again.');
      });
  };

  const handleDelete = async jobId => {
    if (!window.confirm('Are you sure you want to delete this job?')) return;
    try {
      await axios.delete(`${API_BASE}jobs/${jobId}`);
      setJobs(prev => prev.filter(j => j.id !== jobId));
    } catch (err) {
      console.error('Error deleting job:', err);
      alert('Failed to delete job.');
    }
  };

  const valuesToFill = [
    { name: 'title', label: 'Job Title', placeholder: 'Software Engineer - Full Stack (React, Node.js)', type: 'text' },
    { name: 'yoe', label: 'Years of Experience', placeholder: '2-5 years', type: 'text' },
    { name: 'link', label: 'Application Link', placeholder: 'https://www.linkedin.com/company/think41/', type: 'url' },
    { name: 'job_location', label: 'Job Location', placeholder: 'Remote, On-site, or Hybrid', type: 'text' },
    { name: 'job_type', label: 'Job Type', placeholder: 'Full-time, Part-time, Contract', type: 'text' },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 overflow-hidden p-8">
      <div className="flex gap-6">
        {/* Job Form */}
        <div className="flex-1">
          <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-xl p-8 border border-gray-200">
            <div className="mb-8 flex items-center justify-between">
              <h2 className="text-3xl font-bold text-gray-800">Create New Job</h2>
              <button
                type="button"
                className="ml-4 bg-white hover:bg-gray-50 p-2 rounded-full shadow border border-gray-200 transition-all duration-300 hover:shadow-md"
                onClick={() => setSidebarOpen(true)}
                title="View My Jobs"
              >
        <ListTodo className="h-5 w-5 text-gray-700" />
        </button>
            </div>
            <p className="text-gray-600 mb-6">Fill in the details to post a new job opportunity</p>
            <div className="space-y-6">
              {valuesToFill.map(({ name, label, placeholder, type }) => (
                <div key={name}>
                  <label htmlFor={name} className="block text-sm font-semibold text-gray-700 mb-2">
                    {label}
                  </label>
                  <input
                    type={type}
                    name={name}
                    id={name}
                    placeholder={placeholder}
                    value={job[name]}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-1 focus:border-green-500 bg-gray-50 focus:bg-white transition"
                    required
                  />
                </div>
              ))}
            </div>
            <div className="mt-8 pt-6 border-t border-gray-200">
              <button
                type="submit"
                className="w-full bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white font-semibold py-4 px-6 rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-[1.02] focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
              >
                Create Job Posting
              </button>
            </div>
          </form>
        </div>

        {/* Sidebar */}
        {sidebarOpen && (
          <JobSidebar
            sidebarOpen={sidebarOpen}
            jobs={jobs}
            onDelete={handleDelete}
            onClose={() => setSidebarOpen(false)}
          />
        )}
      </div>
    </div>
  );
}
